import React from 'react';
import styled from 'styled-components';

import Bubble from '../../../../components/Bubble/Bubble';
import Icon from '../../../../components/Icon/Icon';
import { SpreadsheetSliderTabButton } from '../SpreadsheetSlider/slider-components';

const CounterWrapper = styled.div`
  position: absolute;
  z-index: 100;
  top: 0;
  right: 0;
  margin-top: 4px;
  margin-right: 5px;
`;

const ErrorsCounter = ({ errorsCount }) => {
  return (
    <CounterWrapper data-testid="spreadsheet-error-count">
      <Bubble variant="feedback-negative">{errorsCount}</Bubble>
    </CounterWrapper>
  );
};

const SliderErrorsTabIcon = ({ onClick, active, open, getErrors, 'aria-label': ariaLabel }) => {
  const errorsCount = getErrors().length;
  return (
    <SpreadsheetSliderTabButton
      key="spreadsheet-error-tab"
      onClick={() => onClick('spreadsheet-error-tab')}
      theme={{ active: active === 'spreadsheet-error-tab' && open }}
      data-testid="slider-error-tab-button"
      aria-label={ariaLabel}
    >
      <Icon type="error" size="xxl" data-testid="spreadsheet-error-tab-icon" />
      {errorsCount !== 0 && <ErrorsCounter errorsCount={errorsCount} />}
    </SpreadsheetSliderTabButton>
  );
};

export default SliderErrorsTabIcon;
